import { HttpErrorResponse } from '@angular/common/http';
import { inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { catchError, exhaustMap, filter, switchMap, withLatestFrom } from 'rxjs';
import { errMessage } from '@ui';
import { OrgUsersActions } from '../state/org-users/org-users.actions';
import { orgUsersFeature } from '../state/org-users/org-users.feature';
import { OrgUsersService } from '../../services/org-users.service';
import { SharedActions } from '../state/shared/shared.actions';

export const startLoadingOrgUsers$ = createEffect(
  (actions$ = inject(Actions), store = inject(Store)) =>
    actions$.pipe(
      ofType(OrgUsersActions.startLoadingOrgUsers),
      withLatestFrom(
        store.select(orgUsersFeature.selectListLoaded),
        store.select(orgUsersFeature.selectIsLoading),
      ),
      filter(([, listLoaded, isLoading]) => !listLoaded && !isLoading),
      exhaustMap(() => [
        OrgUsersActions.setIsLoading({ isLoading: true }),
        OrgUsersActions.loadOrgUsers(),
      ]),
    ),
  { functional: true },
);

export const loadOrgUsers$ = createEffect(
  (actions$ = inject(Actions), service = inject(OrgUsersService)) =>
    actions$.pipe(
      ofType(OrgUsersActions.loadOrgUsers),
      switchMap(() =>
        service.getOrgUsers().pipe(
          switchMap((response) => [
            OrgUsersActions.loadOrgUsersSuccess({ orgUsers: response.users }),
            OrgUsersActions.setIsLoading({ isLoading: false }),
          ]),
          catchError((response: HttpErrorResponse) => [
            OrgUsersActions.loadOrgUsersFail(),
            OrgUsersActions.setIsLoading({ isLoading: false }),
            SharedActions.showMessage({ error: errMessage(response) }),
          ]),
        ),
      ),
    ),
  { functional: true },
);
